import { Minus, Share2 } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface DepartmentBulkActionsBarProps {
  selectedCount: number
  onClearSelection: () => void
  onShare: () => void
}

export function DepartmentBulkActionsBar({
  selectedCount,
  onClearSelection,
  onShare,
}: DepartmentBulkActionsBarProps) {
  return (
    <div className="flex items-center justify-between bg-white border border-[#d6dae1] rounded-xl px-4 py-2.5">
      <div className="flex items-center gap-3">
        <button
          onClick={onClearSelection}
          className="cursor-pointer flex items-center justify-center"
        >
          <Minus className="h-4 w-4 text-primary" />
        </button>
        <span className="text-sm font-semibold text-[#1c1c1c]">
          {selectedCount} Department{selectedCount !== 1 ? 's' : ''} Selected
        </span>
      </div>

      <Button
        variant="outline"
        size="sm"
        onClick={onShare}
        className="gap-2 border-primary text-primary hover:bg-primary/10"
      >
        <Share2 className="h-4 w-4" />
        Share
      </Button>
    </div>
  )
}
